import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { Globals } from 'src/app/helpers/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { SharerService } from 'src/app/services/sharer.service';
import { environment } from 'src/environments/environment';
import { UpsiParamService } from 'src/app/services/upsi-param.service';
import { ExcelService } from 'src/app/services/excel.service';
import { AlertComponent } from '../../alert/alert.component';
import { UpsiMasterService } from 'src/app/services/upsi-master.service';
import { UserMasterService } from 'src/app/services/user-master.service';

declare var $: any;
const FILE_NAME = "UPSI Bulk Upload"
@Component({
  selector: 'app-upsibulk-data',
  templateUrl: './upsibulk-data.component.html',
  styleUrls: ['./upsibulk-data.component.css'],
  providers: [Globals]

})
export class UpsibulkDataComponent implements OnInit {

  sharerName: String;
  SearchDateFrom: String;
  SearchDateTo: String;
  dtUpsiData: DataTables.Settings = {}
  dtUpsiDataTrigger: Subject<any> = new Subject();
  UPSIBulkData: Array<any> = [];
  documentManagementId: String;
  selectedItems: Array<any> = [];
  erronousSelectedItemsForWhichSaveBeDisbaled: Array<any> = [];
  fileSizeError: any;
  fileExtensionError: any;
  fileExtension: any;
  isUploadNotValid: any;
  filesToUpload: any;
  errorLogs: any = [];
  selectedAll: boolean = false;
  ipLocalPc: any;

  constructor(private upsiDatailsService: UpsiParamService, private sharerService: SharerService, private route: ActivatedRoute,
    public globals: Globals, private excelService: ExcelService, private commonFunction: CommonFunction, private alert: AlertComponent, private router: Router, private upsiMasterService: UpsiMasterService, private userMasterService: UserMasterService) { }

  ngOnInit() {
    // console.log(this.router.url)
    this.dtUpsiData = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: false,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      // destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [14, 'desc'],
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Sharer History List',
          title: 'Sharer History List',
          extend: 'excel',
          exportOptions: {
            columns: [2, 4, 6, 7, 8, 9, 10, 11, 12, 13],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },
        },
        {
          text: '<i class="fa fa-files-o"></i> Export to PDF',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Sharer History List',
          title: 'Sharer History List',
          extend: 'pdf',
          orientation: 'landscape',
          pageSize: 'A3',
          exportOptions: {
            columns: [2, 4, 6, 7, 8, 9, 10, 11, 12, 13]
          }
        }
      ]

    }

    this.fetchUpsiBulkData();
    // this.sharerService.getClientIp().subscribe((response) => {
    //   // var ip = JSON.parse(response['_body']).ip;
    //   var ip = (response['ip']);
    //   this.ipLocalPc = ip
    // });
  }

fetchUpsiBulkData() {
  this.upsiDatailsService.getUpsiBulkData().subscribe(response => {
    // console.log(response);

    if (!response.status) {
      const fixedData = response.data.map(row => {
        const parsedPublicDate = this.parseExcelDate(row.PublicDate);
        const parsedSharedDate = this.parseExcelDate(row.SharedDate);
        const parsedInitiationDate = this.parseExcelDate(row.DateOfInitiation);
        // console.log('Parsed PublicDate:', parsedPublicDate?.toISOString(), 'Original:', row.PublicDate);

        return {
          ...row,
          PublicDate: parsedPublicDate,
          SharedDate: parsedSharedDate,
          DateOfInitiation: parsedInitiationDate,
          Date: parsedPublicDate // Optional: for UI column 'Date'
        };
      });

      this.UPSIBulkData = fixedData;

      // Re-initialize DataTable
      const dataTable = $("#bulk-table").DataTable();
      if (dataTable) {
        dataTable.destroy();
      }

      this.dtUpsiDataTrigger.next();
    } else {
      this.alert.error("UPSI Bulk data failed to fetch.");
    }
  });
}




  // searchData() { console.log(this.router.url) }

  // clear() { console.log(this.router.url) }

  addUpsiDetails(detailId) {

    //This functonality can be achived by two ways
    //1. createing a new function to proccess it
    //2. use the already created fucntion for processing bulk entries but to use only with the selected id

    //Since #1 has issues with email, and maintaining 2 approaches for the same thing will create overhead for any further developments.
    //Hence using #2 approach here as well and commenting the existing #1 approach

    let selectedUPSI = this.UPSIBulkData.find(item => item._id === detailId)
    let UPSIDetailObject = {
      "_id": selectedUPSI._id,
      "sharerType": selectedUPSI.SharerType,
      "receipientType": selectedUPSI.RecipientType,
      "typeOfShared": selectedUPSI.TypeOfShared,
      "purposeForSharing": selectedUPSI.purposeForSharing,
      "sharedDate": selectedUPSI.SharedDate,
      "sharedTime": selectedUPSI.SharedTime,
      "publicDate": selectedUPSI.PublicDate,
      "publicTime": selectedUPSI.PublicTime,
      "possessionOfUPSI": selectedUPSI.possessionOfUPSI,
      "modeOfSharing": selectedUPSI.modeOfSharing,
      "DateOfInitiation": selectedUPSI.DateOfInitiation,
      "NatureofUPSI": selectedUPSI.NatureofUPSI._id,
      "PublicStatus": selectedUPSI.PublicStatus,
      "NatureText": selectedUPSI.PublicStatus.Item,
      "sharerId": selectedUPSI.SharerId._id,
      "recipientUserIDs": selectedUPSI.Recipients,
      "IPAddress": selectedUPSI.IPAddress,
      "uniqueHash": selectedUPSI.uniqueHash
    }

    let list = [UPSIDetailObject]
    let data = {
      list: list
    }

    this.upsiDatailsService.addSelectedUpsiBulkData(data)
      .subscribe((response: any) => {

        if (response.status === 0) {
          this.alert.success(response.message);
        } else {
          this.alert.error(response.message)
        }
        this.fetchUpsiBulkData()
      })
    // console.log(list)


    /*
    let selectedUPSI = this.UPSIBulkData.find(item => item._id === detailId)
    let UPSIDetailObject = {
      "_id": selectedUPSI._id,
      "sharerType": selectedUPSI.SharerType,
      "receipientType": selectedUPSI.RecipientType,
      "typeOfShared": selectedUPSI.TypeOfShared,
      "purposeForSharing": selectedUPSI.purposeForSharing,
      "sharedDate": selectedUPSI.SharedDate,
      "sharedTime": selectedUPSI.SharedTime,
      "publicDate": selectedUPSI.PublicDate,
      "publicTime": selectedUPSI.PublicTime,
      "possessionOfUPSI": selectedUPSI.possessionOfUPSI,
      "modeOfSharing": selectedUPSI.modeOfSharing,
      "DateOfInitiation": selectedUPSI.DateOfInitiation,
      "NatureofUPSI": selectedUPSI.NatureofUPSI._id,
      "PublicStatus": selectedUPSI.PublicStatus,
      "NatureText": selectedUPSI.PublicStatus.Item,
      "sharerId": selectedUPSI.SharerId._id,
      "recipientUserIDs": selectedUPSI.Recipients,
      "IPAddress": selectedUPSI.IPAddress,
      "uniqueHash": selectedUPSI.uniqueHash
    }
    this.upsiDatailsService.addToUPSIDetails(UPSIDetailObject)
      .subscribe((response) => {
        if (!response.status) {
          // success
          this.alert.success(response.message);
          this.fetchUpsiBulkData()
        } else {
          this.alert.error(response.message)
        }
      })
   */

  }

  addSelectedUpsiDetails() {
    let list = this.UPSIBulkData.filter(i => this.selectedItems.includes(i._id))
    list = list.map(item => {
      return {
        "_id": item._id,
        "sharerType": item.SharerType,
        "receipientType": item.RecipientType,
        "typeOfShared": item.TypeOfShared,
        "purposeForSharing": item.purposeForSharing,
        "sharedDate": item.SharedDate,
        "sharedTime": item.SharedTime,
        "publicDate": item.PublicDate,
        "publicTime": item.PublicTime,
        "possessionOfUPSI": item.possessionOfUPSI,
        "modeOfSharing": item.modeOfSharing,
        "DateOfInitiation": item.DateOfInitiation,
        "NatureofUPSI": item.NatureofUPSI._id,
        "PublicStatus": item.PublicStatus,
        "NatureText": item.PublicStatus.Item,
        "sharerId": item.SharerId._id,
        "recipientUserIDs": item.Recipients,
        "IPAddress": item.IPAddress,
        "uniqueHash": item.uniqueHash
      }
    })
    let data = {
      list: list
    }
    this.upsiDatailsService.addSelectedUpsiBulkData(data)
      .subscribe((response: any) => {
        if (response.status === 0) {
          this.alert.success(response.message);
        } else {
          this.alert.error(response.message)
        }
        this.fetchUpsiBulkData();
      })
    // console.log(list)
  }

  deleteSelectedUpsiDetails() {
    let data = {
      ids: this.selectedItems
    }
    this.upsiDatailsService.deleteSelectedUpsiBulkData(data).subscribe((response: any) => {
      if (response.status === 0) {
        this.alert.success(response.message);
        this.fetchUpsiBulkData()
      } else {
        this.alert.error(response.message)
      }
    })
  }

  selectUnselectAllUPSI(ev) {
    if (ev.target.checked) {
      this.selectedItems = []
      for (let item of this.UPSIBulkData) {

        if (!this.hasError(item)) {
          this.selectedItems.push(item._id);
        }
      }
      // console.log(this.selectedItems)
    } else {
      this.selectedItems.length = 0;
    }
    this.erronousSelectedItemsForWhichSaveBeDisbaled.length = 0;
  }

  selectUnselectAllInvalidUPSI() {
    this.selectedItems = []
    this.selectedAll = false;
    for (let item of this.UPSIBulkData) {

      if (this.hasError(item)) {
        this.selectedItems.push(item._id);
        this.erronousSelectedItemsForWhichSaveBeDisbaled.push(item._id);
      }
    }

  }

  selectUnselectUpsi(ev, data) {
    var id = data._id;
    if (ev.target.checked) {
      this.selectedItems.push(id)
      let isAllChecked = true
      for (let i = 1; i <= this.UPSIBulkData.length; i++) {
        if (!$('#selectedUPSIUser' + i).prop('checked')) {
          isAllChecked = false;
          break;
        }
      }
      this.selectedAll = isAllChecked

      //Handling erronousSelectedItemsForWhichSaveBeDisbaled
      if (this.hasError(data)) {
        this.erronousSelectedItemsForWhichSaveBeDisbaled.push(id);
      }
    } else {
      this.selectedItems = this.selectedItems.filter(i => i !== id)
      this.erronousSelectedItemsForWhichSaveBeDisbaled = this.erronousSelectedItemsForWhichSaveBeDisbaled.filter(i => i !== id);
      this.selectedAll = false
    }
  }

  isSelected(id) {
    return this.selectedItems.includes(id);
  }

  editUpsiDetails(detailsId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['bulkData', 'edit', detailsId] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/bulkData/edit/', detailsId]);
  }

  deleteConfirmation(documentManagementId) {
    this.documentManagementId = documentManagementId
    $('#confirmation').modal('toggle');
  }

  deleteRecord(id) {
    this.upsiDatailsService.deleteUPSIBulkDataById(id)
      .subscribe((response) => {
        if (response.status === 0) {
          this.alert.success(response.message)
          $('#confirmation').modal('toggle');
          this.fetchUpsiBulkData()
        } else {
          this.alert.error(response.message)
          $('#confirmation').modal('toggle');
        }
      })
  }

  allExtensions() {
    return ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt", "pptx", "mp4", "apk", "bat", "bin", "cgi", "com", "exe", "jar", "py", "wsf", "aif", "cda", "iff", "mid", "midi", "mp3", "mpa", "wav", "wma", "wpl", "avi", "flv", "h264", "m4v", "mkv", "mov", "mpg", "mpeg", "rm", "swf", "vob", "wmv", "3g2", "3gp", "odt", "msg", "rtf", "tex", "wks", "wps", "wpd", "ods", "xlr", "key", "odp", "pps", "accdb", "dat", "db", "dbf", "log",
      "mdb", "pdb", "sav", "sql", "tar", "bak", "cab", "cfg", "cpl", "cur", "dll", "dmp", "drv", "icns", "ico", "ini", "lnk", "msi", "sys", "tmp", "asp", "aspx", "cer", "cfm", "cgi", "pl", "css", "htm", "html", "js", "jsp", "part", "php", "rss", "xhtml", "ai", "bmp", "gif", "ico", "max", "obj", "ps", "psd", "svg", "tif", "tiff", "3ds", "3dm"];

  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  fileChanged($event) {
    var count = 0;
    var self = this;
    // console.log('file changed', $event.target.files[0])

    var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect($event, $event)
    if (filenameValidation == "Valid") {
      var allowedExtensions = ["csv", "CSV", "xlsx", "XLSX"];
      var filename = $event.target.files[0].name;
      var checkFilesExtension = filename.toString().split('.').pop();
      // console.log(" checkFilesExtension : ====>  ", checkFilesExtension)
      this.fileExtension = filename.split('.');
      // console.log("fileExtension", this.fileExtension);

      this.fileExtension.forEach(function (value, key) {
        // console.log(key + ': ' + value);
        if (self.isInArray(self.allExtensions(), value)) {
          count++;
        }
      });

      // console.log('count : ', count);
      //this.fileExtension = filename.toString().split('.').pop();
      // console.log("filename", filename);


      if (count == 1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
        this.fileExtensionError = false;
        this.fileSizeError = false;
        this.isUploadNotValid = false;
        this.filesToUpload = $event.target.files;
      } else {
        this.fileExtensionError = true;
        this.isUploadNotValid = true;
      }
    } else {
      this.alert.error(filenameValidation);
    }



  }

  getUserDetail() {
    var user = JSON.parse(localStorage.getItem("user"));
    var resources = JSON.parse(localStorage.getItem("resources"));
    var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
    var resourcesData = resources.filter(function (item) {
      return item.Menu === 'UPSI';
    })[0]

    var upsiAdmin;
    if (resourcesData) {
      upsiAdmin = (resourcesData['Menu']) ? true : false
    } else {
      upsiAdmin = false
    }
    var decrEmailId = this.commonFunction.decrypt(user.EmailId);
    var loginUser = {
      id: user._id,
      firstName: user.FirstName,
      lastName: user.LastName,
      upsiAdmin: upsiAdmin,
      // EmailId: user.EmailId,
      EmailId: decrEmailId,
      companyDetails: companyDetails,
      title: user.Title
    }
    return JSON.stringify(loginUser);
  }

  /**
   * Strip rows where required columns (A=Sharer, B=Recipients, C=Nature of UPSI) are all empty
   * so the backend does not treat empty rows as duplicate entries.
   * Uses copy-to-new-sheet approach to avoid spliceRows bugs with large row counts.
   */
  private async stripEmptyRowsFromExcel(file: File): Promise<File> {
    try {
      let ExcelJS: any = await import('exceljs');
      ExcelJS = ExcelJS.default || ExcelJS;
      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
      const srcSheet = workbook.getWorksheet(1) || workbook.worksheets[0];
      if (!srcSheet) return file;

      const getCellStr = (sheet: any, row: number, col: number): string => {
        try {
          const cell = sheet.getCell(row, col);
          const v = cell && cell.value;
          if (v == null || v === undefined) return '';
          if (typeof v === 'object') {
            const t = (v as any).text ?? (v as any).richText;
            if (t != null) return (Array.isArray(t) ? t.map((x: any) => x.text).join('') : String(t)).trim();
            if ((v as any).result != null) return String((v as any).result).trim();
          }
          return String(v).trim();
        } catch (_) {
          return '';
        }
      };

      const colCount = (srcSheet as any).dimensions?.right ?? 10;
      const maxRow = (srcSheet as any).dimensions?.bottom ?? (srcSheet as any).rowCount ?? 1500;

      const newWorkbook = new ExcelJS.Workbook();
      const newSheet = newWorkbook.addWorksheet(srcSheet.name || 'Sheet1');

      for (let c = 1; c <= colCount; c++) {
        const val = srcSheet.getCell(1, c).value;
        if (val !== undefined && val !== null) newSheet.getCell(1, c).value = val;
      }

      let dataRowIndex = 2;
      for (let row = 2; row <= maxRow; row++) {
        const a = getCellStr(srcSheet, row, 1);
        const b = getCellStr(srcSheet, row, 2);
        const c = getCellStr(srcSheet, row, 3);
        if (a === '' && b === '' && c === '') continue;
        for (let col = 1; col <= colCount; col++) {
          try {
            const val = srcSheet.getCell(row, col).value;
            if (val !== undefined && val !== null) newSheet.getCell(dataRowIndex, col).value = val;
          } catch (_) { /* skip */ }
        }
        dataRowIndex++;
      }

      const buffer = await newWorkbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      return new File([blob], file.name, { type: blob.type, lastModified: Date.now() });
    } catch (e) {
      console.warn('Strip empty rows failed, uploading original file', e);
      return file;
    }
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: FormData = new FormData();
      var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
      var xhr = new XMLHttpRequest();
      formData.append("companyID", companyDetails.companyID)
      formData.append("IPAddress", this.ipLocalPc)
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.setRequestHeader('userdetail', this.getUserDetail())
      xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
      xhr.send(formData);
    });
  }

async upload() {
    const fileList = this.filesToUpload;
    if (fileList == null || fileList.length === 0) return;

    const rawFile = fileList[0] as File;
    const isXlsx = rawFile.name && (rawFile.name.endsWith('.xlsx') || rawFile.name.endsWith('.xls'));
    const fileToUpload = isXlsx ? await this.stripEmptyRowsFromExcel(rawFile) : rawFile;

    this.makeFileRequest(environment.pssServerUrl + "upsi/upsiBulkUpload", [], [fileToUpload]).then((result: any) => {
      $("#fileInput").val('');
      if (result.errorList && result.errorList.length) {
        this.alert.errorWithOk(`There was ${result.errorList.length} duplicate data in excel file.`, 'userMaster/upsibulkdata');
      }
      if (result['status'] == 0) {
        this.fetchUpsiBulkData();
      } else {
        this.alert.error("File is empty.");
        this.fetchUpsiBulkData();
      }
    }).catch(() => {
      $("#fileInput").val('');
    });
  }


private parseExcelDate(value: any): Date | null {
  if (!value) return null;

  try {
    if (typeof value === 'number') {
      // Check if it's a JavaScript timestamp (> 10 digits)
      const isTimestamp = value > 100000000000;

      const date = isTimestamp
        ? new Date(value)
        : new Date(Math.round((value - 25569) * 86400 * 1000)); // Excel serial

      return isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    if (typeof value === 'string' && value.trim() !== '') {
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    return null;
  } catch (err) {
    console.error('Date parsing error:', value, err);
    return null;
  }
}





  // generateExcelFile() {
  //   let { companyID } = JSON.parse(localStorage.getItem('companyDetails'))
  //   this.upsiDatailsService.downloadSample(companyID).subscribe((response : any) => {
  //     this.excelService.saveAsExcelFile(response._body, FILE_NAME);
  //     $('#CsvUpload').modal('toggle');
  //     this.alert.note("UPSI Template's acceptable date formats is dd/mm/yyyy (Ex: 23/12/2022), make sure your system's local date format is set accordingly.");
  //   })
  // }
  async generateExcelFile() {
    const { companyID } = JSON.parse(localStorage.getItem('companyDetails'));
    const paramData = { companyID: companyID };

    try {
      // Fetch UPSI sharer list, DigiCompany users, and nature of UPSI for dropdowns; Recipients column is free text (comma-separated)
      const sharerList = this.sharerService.getAllSharerList(paramData);
      const userList = this.userMasterService.getAllUserList();
      const natureOfUPSIList = this.upsiMasterService.getList(paramData);

      const [sharerResponse, userResponse, natureOfUPSIResponse, excelBlob] = await Promise.all([
        sharerList.toPromise(),
        userList.toPromise(),
        natureOfUPSIList.toPromise(),
        this.upsiDatailsService.downloadSample(companyID).toPromise()
      ]);

      let sharerEmails: string[] = [];
      let natureOfUPSIItems: string[] = [];

      // UPSI Sharer list emails
      if (sharerResponse && sharerResponse.status === 0 && sharerResponse.data) {
        sharerEmails = sharerResponse.data.map((sharer: any) => {
          return sharer.email_id || sharer.EmailId || sharer.emailId || sharer.Email || sharer.email || '';
        }).filter((email: string) => email && email.trim() !== '');
      }

      // DigiCompany users emails - merge into sharer dropdown (avoid duplicates)
      const digiCompanyEmails: string[] = [];
      const userData = userResponse?.result || userResponse?.data || (Array.isArray(userResponse) ? userResponse : []);
      if (Array.isArray(userData)) {
        userData.forEach((user: any) => {
          if (user == null || user === undefined) return;
          const email = user.email_id || user.EmailId || user.emailId || user.Email || user.email || '';
          if (email && email.trim() !== '' && !sharerEmails.includes(email) && !digiCompanyEmails.includes(email)) {
            digiCompanyEmails.push(email);
          }
        });
      }
      sharerEmails = [...sharerEmails, ...digiCompanyEmails];

      if (natureOfUPSIResponse && natureOfUPSIResponse.status === 0 && natureOfUPSIResponse.data) {
        natureOfUPSIItems = natureOfUPSIResponse.data.map((item: any) => {
          return item.Item || '';
        }).filter((item: string) => item && item.trim() !== '');
      }


      // Try to use ExcelJS if available, otherwise fallback
      try {
        // Try to import ExcelJS - if not installed, this will fail gracefully
        // Note: Install ExcelJS using: npm install exceljs
        let ExcelJS: any;
        try {
          // @ts-ignore - ExcelJS may not be installed
          ExcelJS = await import('exceljs');
          ExcelJS = ExcelJS.default || ExcelJS;
        } catch (importError) {
          // ExcelJS not installed - use CDN or fallback
          throw new Error('ExcelJS not available');
        }
        
        const workbook = new ExcelJS.Workbook();
        const arrayBuffer = await (excelBlob as Blob).arrayBuffer();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.getWorksheet(1) || workbook.worksheets[0];
        
        if (worksheet) {
          // Get worksheet name for reference
          const mainSheetName = worksheet.name;
          
          // Create helper sheets for dropdown lists (Sharer and Nature of UPSI only; Recipients is free text for comma-separated values)
          let sharerSheet = workbook.getWorksheet('SharerList');
          let natureOfUPSISheet = workbook.getWorksheet('NatureOfUPSIList');
          
          // Create Sharer list sheet if it doesn't exist (hidden)
          if (!sharerSheet && sharerEmails.length > 0) {
            sharerSheet = workbook.addWorksheet('SharerList');
            sharerEmails.forEach((email, index) => {
              sharerSheet.getCell(index + 1, 1).value = email;
            });
            // Hide the sheet so it's not visible as a tab
            sharerSheet.state = 'hidden';
            // Define named range for sharer list
            workbook.definedNames.add('SharerList', `SharerList!$A$1:$A$${sharerEmails.length}`);
          }
          
          // Recipients column (B) is left as free text - users enter multiple recipients as comma-separated values
          
          // Create Nature of UPSI list sheet if it doesn't exist (hidden)
          if (!natureOfUPSISheet && natureOfUPSIItems.length > 0) {
            natureOfUPSISheet = workbook.addWorksheet('NatureOfUPSIList');
            natureOfUPSIItems.forEach((item, index) => {
              natureOfUPSISheet.getCell(index + 1, 1).value = item;
            });
            // Hide the sheet so it's not visible as a tab
            natureOfUPSISheet.state = 'hidden';
            // Define named range for nature of UPSI list
            try {
              workbook.definedNames.add('NatureOfUPSIList', `NatureOfUPSIList!$A$1:$A$${natureOfUPSIItems.length}`);
            } catch (error) {
              // Named range creation failed, will use direct sheet reference
            }
          }
          
          // Re-check natureOfUPSISheet after creation
          if (natureOfUPSIItems.length > 0 && !natureOfUPSISheet) {
            natureOfUPSISheet = workbook.getWorksheet('NatureOfUPSIList');
            if (natureOfUPSISheet) {
              natureOfUPSISheet.state = 'hidden';
            }
          }
          
          // Also hide SharerList if it exists
          if (sharerSheet) {
            sharerSheet.state = 'hidden';
          }

          // Add dropdown for Sharer column (Column A)
          if (sharerEmails.length > 0 && sharerSheet) {
            // Use sheet reference for sharer list - ensure sheet name is properly referenced
            const sharerSheetName = sharerSheet.name;
            const sharerFormula = `'${sharerSheetName}'!$A$1:$A$${sharerEmails.length}`;
            
            // Apply validation to all rows except header (starting from row 2)
            for (let row = 2; row <= 1000; row++) {
              const cell = worksheet.getCell(row, 1);
              cell.dataValidation = {
                type: 'list',
                allowBlank: true,
                formulae: [sharerFormula],
                showErrorMessage: true,
                errorStyle: 'error',
                errorTitle: 'Invalid Value',
                error: 'Please select a value from the dropdown list.'
              };
            }
          } else if (sharerEmails.length > 0) {
            // Fallback: use inline list if sheet wasn't created
            const escapedSharerEmails = sharerEmails.map(email => email.replace(/"/g, '""'));
            const sharerListString = escapedSharerEmails.join(',');
            const sharerFormula = `"${sharerListString}"`;
            
            for (let row = 2; row <= 1000; row++) {
              const cell = worksheet.getCell(row, 1);
              cell.dataValidation = {
                type: 'list',
                allowBlank: true,
                formulae: [sharerFormula],
                showErrorMessage: true,
                errorStyle: 'error',
                errorTitle: 'Invalid Value',
                error: 'Please select a value from the dropdown list.'
              };
            }
          }

          // Recipients column (Column B): no dropdown - users enter multiple recipients as comma-separated values

          // Add dropdown for Nature of UPSI column (Column C - assuming it's column 3)
          if (natureOfUPSIItems.length > 0 && natureOfUPSISheet) {
            // Try using named range first, then fallback to direct sheet reference
            const natureOfUPSISheetName = natureOfUPSISheet.name;
            let natureOfUPSIFormula: string;
            
            // Check if named range exists, otherwise use direct sheet reference
            try {
              const namedRange = workbook.definedNames.get('NatureOfUPSIList');
              if (namedRange) {
                natureOfUPSIFormula = 'NatureOfUPSIList';
              } else {
                natureOfUPSIFormula = `'${natureOfUPSISheetName}'!$A$1:$A$${natureOfUPSIItems.length}`;
              }
            } catch (error) {
              natureOfUPSIFormula = `'${natureOfUPSISheetName}'!$A$1:$A$${natureOfUPSIItems.length}`;
            }
            
            // Apply validation to all rows except header (starting from row 2)
            // Assuming Nature of UPSI is in Column C (column 3)
            for (let row = 2; row <= 1000; row++) {
              const cell = worksheet.getCell(row, 3);
              if (cell) {
                try {
                  cell.dataValidation = {
                    type: 'list',
                    allowBlank: true,
                    formulae: [natureOfUPSIFormula],
                    showErrorMessage: true,
                    errorStyle: 'error',
                    errorTitle: 'Invalid Value',
                    error: 'Please select a value from the dropdown list.'
                  };
                } catch (error) {
                  // Skip cells that fail validation
                }
              }
            }
          } else if (natureOfUPSIItems.length > 0) {
            // Fallback: use inline list if sheet wasn't created
            const escapedNatureOfUPSIItems = natureOfUPSIItems.map(item => item.replace(/"/g, '""'));
            const natureOfUPSIListString = escapedNatureOfUPSIItems.join(',');
            const natureOfUPSIFormula = `"${natureOfUPSIListString}"`;
            
            // Assuming Nature of UPSI is in Column C (column 3)
            for (let row = 2; row <= 1000; row++) {
              const cell = worksheet.getCell(row, 3);
              if (cell) {
                cell.dataValidation = {
                  type: 'list',
                  allowBlank: true,
                  formulae: [natureOfUPSIFormula],
                  showErrorMessage: true,
                  errorStyle: 'error',
                  errorTitle: 'Invalid Value',
                  error: 'Please select a value from the dropdown list.'
                };
              }
            }
          }
        }

        // Convert workbook back to buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const modifiedBlob = new Blob([buffer], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        this.excelService.saveAsExcelFile(modifiedBlob, FILE_NAME);
      } catch (excelError) {
        console.warn('ExcelJS not available, using original file:', excelError);
        // Fallback: save original file
        this.excelService.saveAsExcelFile(excelBlob as Blob, FILE_NAME);
      }

      $('#CsvUpload').modal('toggle');
      this.alert.note1(
        "UPSI Template's acceptable date formats is dd/mm/yyyy (Ex: 23/12/2022), make sure your system's local date format is set accordingly.",
        () => {
          this.clearModalsAndBackdrop();
        }
      );
    } catch (error) {
      console.error('Error generating Excel file:', error);
      this.alert.error('Error generating Excel template. Please try again.');
    }
  }

  clearModalsAndBackdrop(): void {
    // Force hide all open modals
    $('.note-alert2').modal('hide');

    // Remove any lingering modal backdrops
    $('.modal-backdrop').remove();

    // Remove 'modal-open' class from body if still present
    $('body').removeClass('modal-open').css('padding-right', '');
  }



  showErrorDialog(id) {
    this.errorLogs = this.UPSIBulkData.find(i => i._id === id).errorLogs
    $('#ErrorDialog').modal('toggle');
  }

  hasError(record) {
    return Object.keys(record.errorLogs).some(i => record.errorLogs[i].length > 0)
  }

  arrOfKeys(obj) {
    return Object.keys(obj).filter(i => this.errorLogs[i].length)
  }

maskEmail(email: string): string {
  if (email) {
    const [username, domain] = email.split('@');
    return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
  }
  return '';
}
}

